import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import LeftPanel from "./LeftPanel";
import apiClient from "../common/apiClient";

const ForgotPassword = () => {
    const [mobile, setMobile] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleMobileChange = (e) => {
        setMobile(e.target.value);
        if (error) setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        if (!mobile || mobile.length !== 10) {
            setError("Please enter a valid 10-digit mobile number.");
            setLoading(false);
            return;
        }

        try {
            const response = await apiClient(
                "post",
                "/cjidnvij/ceksfbuebijn/user/forgot-password/send-otp",
                { mobile }
            );

            if (response.success && response.data.success) {
                navigate("/verify-otp", { state: { mobile } });
            } else {
                setError(response.data?.message || response.error?.message || "Failed to send OTP. Please try again.");
            }
        } catch (err) {
            setError("An unexpected error occurred. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex h-screen w-full overflow-hidden">
            <LeftPanel />
            <form
                onSubmit={handleSubmit}
                className="mx-4 lg:mx-28 mb-28 flex items-center"
            >
                <div className="flex-1 max-w-lg rounded-lg mt-10">
                    {/* <p className="text-4xl text-gray-800 mb-1">Welcome to</p>
                    <p className="text-5xl font-bold text-[#503691] mb-4">PRObroker</p> */}
                    <p className="text-3xl font-bold mb-4">Forgot Password</p>
                    <p className="text-gray-600 mb-6">Enter your registered mobile number to receive an OTP.</p>

                    <div className="relative mb-4">
                        <FaPhoneAlt className="absolute top-1/2 left-4 transform -translate-y-1/2 text-[#503691]" />
                        <input
                            type="number"
                            placeholder="Enter Your Contact Number"
                            value={mobile.slice(0, 10)}
                            onChange={handleMobileChange}
                            className="w-full px-10 py-3 border border-gray-300 rounded-md no-spinner"
                            required
                        />
                    </div>

                    {error && (
                        <div className="text-red-600 bg-red-50 border border-red-200 rounded-lg p-3 text-center mb-4 shadow-sm">
                            <div className="flex items-center justify-center gap-2">
                                <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                                <span className="font-medium">{error}</span>
                            </div>
                        </div>
                    )}

                    <button
                        type="submit"
                        className="w-full h-11 bg-[#503691] text-white rounded-full font-semibold hover:bg-[#5b54e6] disabled:opacity-50"
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Send OTP"}
                    </button>

                    <div className="text-center mt-6">
                        <Link to="/login" className="text-[#503691] font-semibold">
                            Back to Login
                        </Link>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ForgotPassword;
